<template>
  <ipub-model :title="'Generate '+this.type"
              width="920px"
              :visable="isVisable"
              @cancel="cancel"
              confirmText="Generate">
    <ipub-form ref="add-pdf-form"
               :model="params"
               autocomplete="off"
               :rules="rules">
      <ipub-form-item prop="email"
                      label="Email">
        <ipub-input placeholder="Email"
                    v-model.trim="params.email" />
      </ipub-form-item>
      <ipub-form-item prop="billTo"
                      label="Bill To">
        <ipub-textarea placeholder="Bill To"
                       v-model.trim="params.billTo" />
      </ipub-form-item>
      <div v-if="type === 'Invoice'"
           class="ipub-p2">
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="invoiceDate"
                            label="Date of Invoice">
              <ipub-date-picker placeholder="Date of Invoice"
                                v-model="params.invoiceDate" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="statusTime"
                            label="Date of Order">
              <ipub-date-picker placeholder="Date of Order"
                                v-model="params.statusTime" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item prop="coAuthors"
                        label="Name of Co-Authors">
          <ipub-textarea placeholder="Name of Co-Authors"
                         v-model.trim="params.coAuthors" />
        </ipub-form-item>
        <ipub-row :gutter="20">
          <ipub-col :span="4">
            <ipub-form-item prop="price"
                            label="APC">
              <ipub-input placeholder="APC"
                          number
                          :fixed="2"
                          v-model.trim="params.price" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop="discount"
                            label="Discount">
              <ipub-input placeholder="Discount"
                          number
                          :fixed="2"
                          v-model.trim="params.discount" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop="fee"
                            label="Transaction Fee (%)">
              <ipub-input placeholder="Transaction Fee (%)"
                          number
                          v-model.trim="params.fee" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
      </div>
      <div v-else-if="type === 'Receipt'">
        <ipub-row :gutter="20">
          <ipub-col :span="6">
            <ipub-form-item prop="receiptDate"
                            label="Receipt Date">
              <ipub-date-picker placeholder="Receipt Date"
                                v-model="params.receiptDate" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="6">
            <ipub-form-item prop="receiptReceivedDate"
                            label="Date Received">
              <ipub-date-picker placeholder="Date Received"
                                v-model="params.receiptReceivedDate" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-form-item prop="receiptAmount"
                        label="Amount">
          <ipub-input placeholder="Amount"
                      number
                      v-model.trim="params.receiptAmount" />
        </ipub-form-item>
      </div>
      <ipub-form-item prop="scale"
                      label="File Quality (The file size will increase with the file quality, please select the file quality that meets your needs)">
        <ipub-select placeholder="File Quality"
                     v-model="scale">
          <ipub-select-option v-for="item in 4"
                              :key="'scale'+item"
                              :value="item">{{item}} Level</ipub-select-option>
        </ipub-select>
      </ipub-form-item>
      <ipub-form-item prop="preview"
                      label="Preview">
        <div class="showPDFDialog">
          <div id="showPDFDialogpdf">
            <div class="pdf-content">
              <template v-if="type==='Invoice'">
                <div class="pdf-content-icon">
                  <div class="ipub-h1 tl">
                    Invoice
                  </div>
                  <div class="tr">
                    <img :src="logo"
                         alt="">
                  </div>
                </div>
                <ipub-row>
                  <ipub-col :span='6'>
                    <div class="font-color mar-b-20">Bill To</div>
                    <div v-html="params.billTo&&params.billTo.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                  </ipub-col>
                  <ipub-col class="tr"
                            :span='6'>
                    <div>IMR PRESS PTE. LTD.</div>
                    <div>#05-02F, 50 Tagore Lane, 787494 Singapore<br />
                      <strong>invoice@imrpress.com</strong>
                    </div>
                  </ipub-col>
                </ipub-row>
                <div class="pdf-content-line"></div>
                <div class="flex mar-b-12">
                  <span style="width: 244px">Date of Invoice</span>
                  <div style="width:calc(100% - 278px); margin-left:34px">{{$moment(params.invoiceDate).format('DD MMMM YYYY')}}</div>
                </div>
                <div class="flex mar-b-12">
                  <span style="width: 244px">Manuscript / Invoice No.</span>
                  <div style="width:calc(100% - 278px); margin-left:34px">{{params.code}}</div>
                </div>
                <div class="flex mar-b-12">
                  <span style="width: 244px">Your Order</span>
                  <div style="width:calc(100% - 278px); margin-left:34px">
                    by e-mail ({{params.email}}) on {{$moment(params.statusTime).format('DD MMMM YYYY')}}
                  </div>
                </div>
                <div class="flex mar-b-12">
                  <span style="width: 244px">Article Title</span>
                  <div style="width:calc(100% - 278px); margin-left:34px">
                    <div class="pdf-content-article-title"
                         v-html="params.title"></div>
                  </div>
                </div>
                <div class="flex mar-b-12">
                  <span style="width: 244px">Name of Co-Author<template v-if="params.coAuthors&&params.coAuthors.split(';').length>1">s</template></span>
                  <div style="width:calc(100% - 278px); margin-left:34px">
                    <div class="pdf-content-article-title"
                         v-html="params.coAuthors&&params.coAuthors.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                  </div>
                </div>
                <div class="flex mar-b-12">
                  <span style="width: 244px">Terms of Payment</span>
                  <div style="width:calc(100% - 278px);margin-left:34px">5 days</div>
                </div>
                <div class="pdf-content-table">
                  <div class="pdf-content-table-th">
                    <div style="width: 55%">Description</div>
                    <div style="width: 20%">Currency</div>
                    <div style="width: 25%">Amount</div>
                  </div>
                  <div class="pdf-content-table-tr">
                    <div style="width: 55%">Open Access Publication Fee</div>
                    <div style="width: 20%">USD</div>
                    <div style="width: 25%">{{formatMoney(params.price, 2, '')}}</div>
                  </div>
                  <div class="pdf-content-table-tr">
                    <div style="width: 55%">Discount</div>
                    <div style="width: 20%">USD</div>
                    <div style="width: 25%">{{formatMoney(params.discount, 2, '')}}</div>
                  </div>
                  <div class="pdf-content-table-tr">
                    <div style="width: 55%">Transaction Fee ({{params.fee}}%)</div>
                    <div style="width: 20%">USD</div>
                    <div style="width: 25%">{{formatMoney((params.price-params.discount)*params.fee/100, 2, '')}}</div>
                  </div>
                  <div class="pdf-content-table-tr">
                    <div style="width: 55%">Total</div>
                    <div style="width: 20%">USD</div>
                    <div style="width: 25%">{{formatMoney((params.price-params.discount)*(100+params.fee)/100, 2, '')}}</div>
                  </div>
                </div>
                <div class="mar-b-30">
                  Important: <span style="text-decoration: underline;">Please provide the Invoice No. ({{params.code}}) when you pay.</span>
                </div>
                <div class="mar-b-20"
                     style="font-size:25px">
                  Accepted Payment Methods
                </div>
                <div class="mar-b-8">1. Online Payment by Credit Card in United States Dollar (USD)</div>
                <p class="font-color mar-b-20">
                  Please visit <a class="link-color"
                     href="https://www.imrpress.com/credit">https://www.imrpress.com/credit</a> to pay by credit card. We accept payments in United States Dollar (USD) made VISA, MasterCard or AmericanExpress.
                </p>
                <div class="mar-b-8">2. Wire Transfer in United Stated Dollar (USD)</div>
                <div class="font-color mar-b-20">Invoicing in USD must be made by wire transfer to the IMR PRESS PTE. LTD. bank account. Banks fees must be paid by the customer, for both, payer and payee so that IMR PRESS PTE. LTD. can receive the full invoiced amount.</div>
                <div class="font-color">
                  <div>
                    <span style="display:inline-block;width: 160px">Account holder</span>IMR Press PTE. LTD
                  </div>
                  <div>
                    <span style="display:inline-block;width: 160px">Bank Name</span>COMMUNITY FEDERAL SAVINGS BANK
                  </div>
                  <div>
                    <span style="display:inline-block;width: 160px">Account number</span>8313391230
                  </div>
                  <div>
                    <span style="display:inline-block;width: 160px">Swift/BIC</span>CMFGUS33
                  </div>
                  <div>
                    <span style="display:inline-block;width: 160px">Routing number</span>026073150
                  </div>
                  <div class="mar-b-30">
                    <span style="display:inline-block;width: 160px">Wise's address</span>89-16 Jamaica Ave，Woodhaven，NY 11421，United States
                  </div>
                  <div>In case of any problems or questions regarding your payment, please contact invoice@imrpress.com</div>

                </div>
              </template>
              <template v-else-if="type=='Receipt'">
                <div class="pdf-content-icon">
                  <div class="tl">
                    <img :src="logo"
                         alt="">
                  </div>
                  <div class="ipub-h1 tr">
                    Receipt
                  </div>
                </div>
                <ipub-row>
                  <ipub-col :span='6'>
                    <div style="margin-right: 35px">
                      <div style="height: 60px;margin: 40px 0">
                        Receipt: {{params.code}} <br />
                        Receipt Date: {{$moment(params.receiptDate).format('DD MMMM YYYY')}}
                      </div>
                      <div class="pdf-content-line"></div>
                      <div class="font-color mar-b-10">From</div>
                      <div>IMR PRESS PTE. LTD.</div>
                      <div>#05-02F, 50 Tagore Lane, 787494 Singapore<br />
                        <strong>invoice@imrpress.com</strong>
                      </div>
                    </div>
                  </ipub-col>
                  <ipub-col :span='6'>
                    <div style="margin-left: 35px">
                      <div style="height: 60px;margin: 40px 0"></div>
                      <div class="pdf-content-line"></div>
                      <div class="font-color mar-b-10">Bill To</div>
                      <div class="mar-b-10"
                           v-html="params.billTo&&params.billTo.replace(/\r\n/g,'<br/>').replace(/\n/g,'<br/>').replace(/\s/g,' ')"></div>
                      <div>{{params.email}}</div>
                    </div>
                  </ipub-col>
                </ipub-row>
                <div style="width:100%;margin-bottom:50px"
                     class="pdf-content-table">
                  <div class="pdf-content-table-th">
                    <div style="width: 85%">Description</div>
                    <div style="width: 15%"
                         class="tr">Amount</div>
                  </div>
                  <div class="pdf-content-table-tr">
                    <div style="width: 85%">Payment confirmation for invoice: {{params.code}}</div>
                    <div style="width: 15%"
                         class="tr">{{formatMoney(params.receiptAmount)}}</div>
                  </div>
                  <div class="pdf-content-table-tr">
                    <div style="width: 85%">Total</div>
                    <div style="width: 15%"
                         class="tr">{{formatMoney(params.receiptAmount)}}</div>
                  </div>
                </div>
                <div>IMR Press confirms that it has received payment of invoice {{params.code}} (Date of invoice: {{$moment(params.acceptTime).format('DD MMMM YYYY')}})</div>
                <div style="width: 300px"
                     class="pdf-content-line"></div>
                <div class="font-color mar-b-10">Amount Received</div>
                <div class="mar-b-20">{{formatMoney(params.receiptAmount, 2, '')}} USD</div>
                <div style="width: 300px"
                     class="pdf-content-line"></div>
                <div class="font-color mar-b-10">Date Received</div>
                <div class="mar-b-100">{{$moment(params.receiptReceivedDate).format('DD MMMM YYYY')}}</div>
                <div class="ipub-h1 mar-b-20"
                     style="font-size:35px;color:#003B76">IMR Press</div>
                <div class="font-color">
                  <div>IMR PRESS PTE. LTD.</div>
                  <div>#05-02F, 50 Tagore Lane,<br />
                    787494 Singapore</div>
                </div>
              </template>
            </div>
          </div>
        </div>
      </ipub-form-item>
    </ipub-form>
    <div slot="footer"
         class="ipub-p2">
      <ipub-button style="width:150px"
                   @click="save"
                   type="primary"
                   plain>Save</ipub-button>
      <ipub-button style="width:150px"
                   @click="confirm"
                   type="primary">Generate PDF</ipub-button>
      <ipub-button style="width:150px"
                   v-if="type==='Invoice'"
                   @click="sendToAuthor"
                   type="primary">Send to Author</ipub-button>
    </div>
  </ipub-model>
</template>

<script>
import { mapGetters } from 'vuex'
import logo from '@/assets/pdf/publish-logo'
import { editorManuscript } from '@/api/editor'
import { manuscript } from '@/api/manuscript'
import apc from '@/api/apc'
import { savePDF } from '@/utils/pdf'
import help from '../../../../utils/help'
export default {
  props: {
    isVisable: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'Invoice',
      validator (val) {
        return ['Invoice', 'Receipt'].indexOf(val) !== -1
      }
    },
    inputData: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      logo,
      params: {},
      rules: {},
      scale: 4,
      formatMoney: help.formatMoney
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage',
    })
  },
  watch: {
    isVisable (val) {
      if (!val) {
        this.params = {}
        this.rules = {}
        help.closeAutocomplete()
      } else {
        this[`get${this.type}Rules`]()
        this.getQuery()
        help.closeAutocomplete()

      }
    }
  },
  methods: {
    async getQuery () {
      const res = await editorManuscript.query(this.inputData.id, {
        sign: this.inputData.sign
      })
      const { statusTime, mauthorList, code, title, acceptTime } = res
      const apcObj = await apc.query(this.inputData.id)
      const data = {
        title,
        code,
        email: '',
        billTo: '',
        invoiceDate: this.$moment(),
        statusTime,
        acceptTime,
        coAuthors: mauthorList && mauthorList.length ? mauthorList.map((item) => { return `${item.firstName} ${item.lastName}` }).join('; ') : '',
        price: apcObj ? apcObj.price : 0,
        discount: 0,
        fee: 5,
        receiptDate,
        receiptReceivedDate,
        receiptAmount
      }
      data.receiptAmount = data.receiptAmount ? data.receiptAmount : data.price
      this.params = data

      let inv = await manuscript.getInvoice(this.inputData.id)
      const {
        email, billTo, discount, discountFee, coAuthor, price,
        receiptDate,
        receiptReceivedDate,
        receiptAmount
      } = inv
      this.params = {
        title,
        code,
        email,
        billTo,
        invoiceDate: this.$moment(),
        statusTime,
        coAuthors: coAuthor,
        price,
        discount,
        fee: discountFee,
        receiptDate,
        receiptReceivedDate,
        receiptAmount: receiptAmount ? receiptAmount : data.price,
        acceptTime
      }
      // console.log(this.params, 'this.pa', this.params.acceptTime)
    },
    async confirm () {
      const flag = this.$refs['add-pdf-form'].validate()
      if (flag) {
        const {
          email, billTo, statusTime, coAuthors, price, discount, fee,
          receiptDate,
          receiptReceivedDate,
          receiptAmount
        } = this.params
        await manuscript.addInvoice(this.inputData.id, {
          email, billTo, orderDate: statusTime, coAuthor: coAuthors, price, discount, discountFee: fee,
          receiptDate,
          receiptReceivedDate,
          receiptAmount
        })
        const el = document.getElementById('showPDFDialogpdf')
        await savePDF(el, this.scale, `${this.params.code} ${this.type}`)
        this.$emit('confirm', this.params)
      }
    },
    async save () {
      const {
        email, billTo, statusTime, coAuthors, price, discount, fee,
        receiptDate,
        receiptReceivedDate,
        receiptAmount
      } = this.params
      await manuscript.addInvoice(this.inputData.id, {
        email, billTo, orderDate: statusTime, coAuthor: coAuthors, price, discount, discountFee: fee,
        receiptDate,
        receiptReceivedDate,
        receiptAmount
      })
      this.$emit('save', this.params)
    },
    async sendToAuthor () {
      const flag = this.$refs['add-pdf-form'].validate()
      if (flag) {
        const {
          email, billTo, statusTime, coAuthors, price, discount, fee,
          receiptDate,
          receiptReceivedDate,
          receiptAmount
        } = this.params
        await manuscript.addInvoice(this.inputData.id, {
          email, billTo, orderDate: statusTime, coAuthor: coAuthors, price, discount, discountFee: fee,
          receiptDate,
          receiptReceivedDate,
          receiptAmount
        })
        const el = document.getElementById('showPDFDialogpdf')
        const file = await savePDF(el, this.scale, `${this.params.code} ${this.type}`, false)
        this.inputData = Object.assign(this.inputData, {
          __file: file
        })
        this.$emit('sendEm', this.inputData)
      }
    },
    cancel () {
      this.$emit('cancel')
    },
    getInvoiceRules () {
      this.rules = {
        email: [
          {
            required: true,
            message:
              'Email' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            type: 'email',
            message: this.LANGUAGE[this.language].inputCorrectEmail
          }
        ],
        billTo: [
          {
            required: true,
            message:
              'Bill To' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            max: 1024,
            message: `Bill To length must not be more than 1024 digits`
          },
        ],
        invoiceDate: [
          {
            required: true,
            message:
              'Date of Invoice' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        statusTime: [
          {
            required: true,
            message:
              'Date of Order' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        coAuthors: [
          {
            required: true,
            message:
              'Name of Co-Authors' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            max: 1024,
            message: `Name of Co-Authors length must not be more than 1024 digits`
          },
        ],
        price: [
          {
            required: true,
            message:
              'APC' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            min: 0,
            message: 'Must be greater than 0'
          }
        ],
        discount: [
          {
            required: true,
            message:
              'Discount' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            min: 0,
            message: 'Must be greater than 0'
          }
        ],
        fee: [
          {
            required: true,
            message:
              'Transaction Fee (%)' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            min: 0,
            max: 100,
            message: 'Please enter 0-100'
          }
        ],
      }
    },
    getReceiptRules () {
      this.rules = {
        email: [
          {
            required: true,
            message:
              'Email' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            type: 'email',
            message: this.LANGUAGE[this.language].inputCorrectEmail
          }
        ],
        billTo: [
          {
            required: true,
            message:
              'Bill To' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        receiptReceivedDate: [
          {
            required: true,
            message:
              'Date Received' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        receiptDate: [
          {
            required: true,
            message:
              'Receipt Date' +
              this.LANGUAGE[this.language].noEmpty
          }
        ],
        price: [
          {
            required: true,
            message:
              'Amount' +
              this.LANGUAGE[this.language].noEmpty
          },
          {
            min: 0,
            message: 'Must be greater than 0'
          }
        ],
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.showPDFDialog {
  height: 900px;
  width: 640px;
  border: 1px solid $line_color;
  #showPDFDialogpdf {
    width: 1280px;
    height: 1800px;
    transform: scale(0.5);
    transform-origin: left top;
    .pdf-content {
      width: 1280px;
      height: 1800px;
      background-repeat: no-repeat;
      background-size: 100% 100%;
      position: relative;
      padding: 98px 127px;
      box-sizing: border-box;
      font-size: 21px;
      line-height: 25px;
      &-icon {
        display: flex;
        justify-content: center;
        color: #003b76;
        font-weight: bold;
        margin-bottom: 50px;
        > div {
          width: 50%;
          font-size: 60px;
        }
      }
      &-line {
        height: 2px;
        width: 100%;
        background: #003b76;
        margin: 25px 0;
      }
      &-article-title {
        font-size: 21px;
        p,
        div,
        h1 {
          font-size: 21px;
        }
      }
      &-table {
        margin-top: 30px;
        margin-bottom: 20px;
        width: 830px;
        &-th {
          display: flex;
          line-height: 50px;
          height: 50px;
          background: #003b76;
          color: #fff;
          font-family: $h_family;
          font-weight: bold;
          > div {
            padding: 0 20px;
            box-sizing: border-box;
          }
        }
        &-tr {
          display: flex;
          line-height: 50px;
          > div {
            padding: 0 20px;
            box-sizing: border-box;
          }
          border-bottom: 2px solid #003b7655;
          &:nth-child(2n + 1) {
            border-bottom: 2px solid #003b76;
          }
        }
      }
    }
  }
}
</style>
